<div [ngClass]="success_sent ? 'modal fade close-mod push-modal-center' : 'modal fade close-mod'" id="free-demo" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-center-align">
        <div class="modal-content">

            <div class="modal-body">
                <button type="button" (click)="clearDemo(requestForm)" class="close" data-dismiss="modal">&times;</button>

                <div class="contactus-details-right enquiry-form">
                    <form #requestForm="ngForm">
                        <h3 *ngIf="!success_sent" id="enquiry-header" class="enquiry-title">Enquiry</h3>

                        <div class="con-tac">

                            <div class="input" *ngIf="!success_sent">
                                <input tabindex="1" required id="name" type="text" name="name" class="input-field" [(ngModel)]="request_demo_info.name" #fullPatientName="ngModel" placeholder="" #nameit />
                                <label for="name" class="input-label">Name<span class="required-marker">*</span></label>

                                <!-- <div class="form-text warning" *ngIf="fullPatientName.touched && fullPatientName.errors?.required && !success_sent">
                                    Name is required!
                                </div> -->
                            </div>


                            <div class="input" *ngIf="!success_sent">
                                <input tabindex="1" required id="organizationId" type="text" name="organization" class="input-field" [(ngModel)]="request_demo_info.organization" #Organization="ngModel" placeholder="" #orgnizationit />
                                <label for="organization" class="input-label">Organization<span class="required-marker">*</span></label>

                                <!-- <div class="form-text warning" *ngIf="Organization.touched && Organization.errors?.required && !success_sent">
                                    Organization is required!
                                </div> -->
                            </div>


                            <div class="input" *ngIf="!success_sent">
                                <input tabindex="2" pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$" name="email" class="input-field" [(ngModel)]="request_demo_info.email" #fullemail="ngModel"
                                    placeholder="" />
                                <label class="input-label" for="email">Email</label>

                                <!-- <div class="form-text warning" *ngIf="fullemail.touched && fullemail.errors?.required && !success_sent">
                                    Email is required!
                                </div> -->
                                <div class="form-text warning" *ngIf="fullemail.touched && fullemail.errors?.pattern ">
                                    Email is invalid!
                                </div>
                            </div>


                            <div class="input" *ngIf="!success_sent">
                                <input tabindex="3" required id="phone" type="text" name="phone" class="input-field" [(ngModel)]="request_demo_info.phone" #fullcontactnumber="ngModel" pattern="^[6-9]\d{9}$" placeholder="" />
                                <label for="phone" class="input-label">Mobile<span class="required-marker">*</span></label>

                                <!-- <div class="form-text warning" *ngIf="fullcontactnumber.touched && fullcontactnumber.errors?.required && !success_sent">
                                    Contact number is required!
                                </div> -->
                                <div class="form-text warning" *ngIf="fullcontactnumber.errors?.pattern">
                                    Invalid mobile number
                                </div>
                            </div>


                            <div class="input" *ngIf="!success_sent">
                                <input tabindex="4" type="text" class="input-field" required placeholder="" name="location" [(ngModel)]="request_demo_info.location" #fulllocation="ngModel">
                                <label for="location" class="input-label">Location<span class="required-marker">*</span></label>

                                <!-- <div class="form-text warning" *ngIf="fulllocation.touched && fulllocation.errors?.required && !success_sent">
                                    Location is required!
                                </div> -->
                            </div>

                            <div class="input" *ngIf="!success_sent">
                                <textarea tabindex="5" class="input-field" placeholder="" name="message" [(ngModel)]="request_demo_info.message"></textarea>
                                <label for="message" class="input-label">Message</label>

                            </div>

                            <div class="text-center">
                                <div class="alert alert-success" role="alert" *ngIf="success_sent">Submitted Successfully!</div>
                                <button *ngIf="!success_sent" type="submit" value="submit" class="btn button brand-button enquiry-but" name="submit_request" (click)="submitRequest();" [disabled]="isInvalid() || isRequestDemoSaving"><i *ngIf="isRequestDemoSaving" class="fas fa-spinner animate-spinner"></i> Submit</button>
                            </div>

                        </div>
                        <!-- con-tac -->
                    </form>
                    <!-- contactus-details-right -->
                </div>
                <!-- contactus-details-right -->
            </div>
        </div>
    </div>
</div>